import { createContext, useMemo, useContext } from "react";
import { useLocation } from "react-router-dom";
import { languagePath } from "../i18n/routing";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import en from "../i18n/en.json";
import fr from "../i18n/fr.json";
import ar from "../i18n/ar.json";

const LanguageContext = createContext();
const translationFiles = { en, fr, ar };

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children, language = "en" }) => {
  const selectedLanguage = translationFiles[language] ? language : "en";
  const location = useLocation();
  const translations = translationFiles[selectedLanguage] || en;
  const direction = selectedLanguage === "ar" ? "rtl" : "ltr";

  const changeLanguage = (language) => {
    if (translationFiles[language]) {
      window.location.assign(languagePath(location.pathname, language) + location.search + location.hash);
    }
  };

  const translate = (key) => {
    return translations[key] || key;
  };

  const theme = useMemo(() => createTheme({ direction }), [direction]);

  return (
    <LanguageContext.Provider
      value={{ selectedLanguage, translate, changeLanguage, translations }}
    >
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </LanguageContext.Provider>
  );
};
